<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formInventoryArticleSearch" novalidate (ngSubmit)="searchArticles()" method="get" role="form">
            <tt-input ttLabel="inventoryarticlesearch_searchtext" [(ttModel)]="setting.searchtext" [ttButtons]="searchTextButtons"></tt-input>
        </form>

        <tt-checkbox ttLabel="only_on_stock" [(ttModel)]="setting.only_on_stock" (ttModelChange)="onChanged($event, 'only_on_stock')"></tt-checkbox>
    </tt-card>

    <tt-list [ttData]="itemsListArticles"></tt-list>

    <tt-card *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
